import PropTypes from 'prop-types';
import { useIsMobile } from '@stores/AppCommonData';
import { useMemo } from 'react';
import Header from './Header';
import Footer from '../Footer/BaseFooter';

const SimpleFlexLayout = ({
  children,
  className,
  showFooter,
  showLogin,
  layoutOptions = {}
}) => {
  const isMobile = useIsMobile();

  const displayFooter = useMemo(() => {
    if (isMobile && layoutOptions.showFooterOnMobile === false) return false;
    return layoutOptions.showFooter ?? showFooter;
  }, [
    isMobile,
    layoutOptions.showFooter,
    layoutOptions.showFooterOnMobile,
    showFooter
  ]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: 'var(--color-base-1)'
      }}
    >
      <Header
        showLogin={layoutOptions.showLogin ?? showLogin}
        className={className}
      />
      {children}
      <Footer display={displayFooter} />
    </div>
  );
};

SimpleFlexLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  className: PropTypes.string,
  showFooter: PropTypes.bool,
  showLogin: PropTypes.bool
};

SimpleFlexLayout.defaultProps = {
  className: '',
  showFooter: true,
  showLogin: false
};

export default SimpleFlexLayout;
